var $window = $(window);
var breakPoint = 767;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();
//var bodyLimitHeight = (windowHeight - 185) * 0.88;

// hamburger
var trigger = document.getElementsByClassName("js-Trigger");
trigger[0].addEventListener("click", function(){
  this.classList.toggle("active");
  $(".st-Header_Navi").toggleClass("active").slideToggle(300);
});
// var trigger = document.getElementById("js-Trigger");
// trigger.addEventListener("click", function(){
//   this.classList.toggle("active");
//   $(".st-Header_Navi").toggleClass("active").slideToggle(300);
// });
// $('.js-Trigger').click(function () {
//   $(this).toggleClass('active');
//   $('.st-Header_Navi').toggleClass('active').slideToggle(300);
// });

function loading(){
  var $loading = $('.idx-Loading');

  setTimeout(function(){
    $loading.fadeOut(200);
  },1500);
  setTimeout(function(){
    $('.idx-Mainvisual').addClass('animated');
  },1700);
}

window.addEventListener('load',function(){
  loading();
});

$('.globalnavi li .anchor a').click(function () {
  $('.js-Trigger').removeClass('active');
  $('.st-Header_Navi').removeClass('active').slideUp(300);
});

if(windowWidth > 767){
  $('.globalnavi .events').hover(function () {
    $('nav.sub').fadeIn(200);
  },function () {
    $('nav.sub').fadeOut(200);
  });
}else{}

//easing-scroll
$(function () {
  $('a[href^=#]').click(function () {
    var speed = 1000;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var hh = $('.st-Header').innerHeight();
    if(windowWidth > 767){
      var position = target.offset().top;
    } else{
      var position = target.offset().top - hh;
    }
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});

//gototop fixed
$(function () {
  var topBtn = $('.st-Footer_Top');
  topBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });
});

window.addEventListener('load',function(){
  // anchor
  var url = $(location).attr('href');
  if (url.indexOf("?id=") == -1) {
  } else {
    var url_sp = url.split("?id=");
    var hash = '#' + url_sp[url_sp.length - 1];
    var target = $(hash);
    var hh = $('.st-Header').innerHeight();
    if(windowWidth > 767){
      var position = target.offset().top;
    } else{
      var position = target.offset().top - hh;
    }
    $("html, body").animate({
      scrollTop: position
    }, 1000, "swing");
  }
});

// $(window).load(function (){
//   $('.idx-Mainvisual').addClass("animated");
//
//   $(".js-Scroll_Animation, .idx-Band_Content").each(function(){
//     var imgPos = $(this).offset().top;
//     var scroll = $(window).scrollTop();
//     var windowHeight = $(window).height();
//     if (scroll > imgPos - windowHeight + windowHeight/10){
//       $(this).addClass("animated");
//     } else {}
//   });
// });

// $(window).scroll(function (){
//   var scroll = $(window).scrollTop();
//   $(".js-Scroll_Animation, .idx-Band_Content").each(function(){
//     var imgPos = $(this).offset().top;
//     var windowHeight = $(window).height();
//     if (scroll > imgPos - windowHeight + windowHeight/10){
//       $(this).addClass("animated");
//     } else {}
//   });
// });

//スライダー
// const slider = () => {
//   $('.js-Slider').each(function(){
//     $(this).slick({
//       dots: true,
//       arrows: true,
//       infinite: true,
//       speed: 500,
//       slidesToShow: 3,
//       slidesToScroll: 1,
//       autoplay: true,
//       autoplaySpeed: 3000,
//       centerMode: true
//     });
//   });
// };
// slider();
// $(document).ready(function(){
//   // slider
//   if (windowWidth > breakPoint) {
//   } else {
//     slider();
//   }
//   var timer = false;
//   $(window).on('resize',function() {
//     var resizeWidth = $(window).width();
//     clearTimeout(timer);
//     timer = setTimeout(function() {
//       if(windowWidth != resizeWidth){
//         if(resizeWidth > breakPoint){
//           $('.js-Slider').slick('unslick');
//         } else {
//           slider();
//         }
//       }
//       windowWidth = resizeWidth;
//     }, 100);
//   });
// });

var slideWidth;
if (windowWidth > breakPoint) {
  var slideWidth = windowWidth * 0.33125;
} else {
  var slideWidth = windowWidth * 0.828125;
}
function slider(){
  $('.js-Slider').each(function(){
    var $this = $(this);
    var slider = $(this).bxSlider({
      // auto: true,
      infiniteLoop: true,
      responsive: true,
      touchEnabled: true,
      controls: true,
      slideWidth: slideWidth,
      slideMargin: 0,
      minSlides: 1,
      maxSlides: 1,
      moveSlides: 1,
      speed: 500,
      useCSS: false,
      pager: true,
      responsive: true
    });
    $(window).on('resize',function() {
      var resizeWidth = $(window).width();
      if(windowWidth != resizeWidth){
        slider.destroySlider();
      }
    });
  });
}
slider();


$(window).load(function(){

  // slider();
  var timer = false;
  $(window).on('resize',function() {
    var resizeWidth = $(window).width();
    clearTimeout(timer);
    timer = setTimeout(function() {
      if(windowWidth != resizeWidth){
        if (resizeWidth > breakPoint) {
          var slideWidth = resizeWidth * 0.33125;
        } else {
          var slideWidth = resizeWidth * 0.828125;
        }
        $('.js-Slider').each(function(){
          var $this = $(this);
          var slider = $(this).bxSlider({
            // auto: true,
            infiniteLoop: true,
            responsive: true,
            touchEnabled: true,
            pager: false,
            controls: true,
            slideWidth: slideWidth,
            slideMargin: 0,
            minSlides: 1,
            maxSlides: 1,
            moveSlides: 1,
            speed: 500,
            useCSS: false,
            pager: true,
            easing: 'swing',
            responsive: true
          });
          $(window).on('resize',function() {
            var resizeWidth = $(window).width();
            if(windowWidth != resizeWidth){
              slider.destroySlider();
            }
          });
        });
      }
      windowWidth = resizeWidth;
    }, 1000);
  });

});


// WEBPACK FOOTER //
// script.js